export default __webpack_public_path__ + "5c7f9aa6ca31415d94866fff63c9b492.jpg";